/**
 * Map an Odoo `stock.picking.state` value to the exact label Odoo shows in its UI, so the
 * scanner's status wording matches Odoo (e.g. `assigned` → "Ready", `confirmed` → "Waiting").
 * Labels read from the live instance's `stock.picking.state` selection (2026-06-25).
 */
const PICKING_STATE_LABELS: Record<string, string> = {
  draft: "Draft",
  waiting: "Waiting Another Operation",
  confirmed: "Waiting",
  assigned: "Ready",
  done: "Done",
  cancel: "Cancelled",
};

/** Odoo-matching label for a picking state; falls back to the raw value if unknown. */
export function pickingStateLabel(state: string): string {
  return PICKING_STATE_LABELS[state] ?? state;
}
